import {
  type GetTen99PolicyJobsQueryFilter,
  type GetTen99PolicyJobsResponse,
  GetTen99PolicyJobsResponseSchema,
} from "@clipboard-health/contract-backend-main";
import { isDefined } from "@clipboard-health/util-ts";
import { useGetQuery, type UseGetQueryOptions } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import { type UseQueryResult } from "@tanstack/react-query";

export function useGetTen99PolicyJobs(
  workerId: string,
  query: GetTen99PolicyJobsQueryFilter,
  options: UseGetQueryOptions<GetTen99PolicyJobsResponse> = {}
): UseQueryResult<GetTen99PolicyJobsResponse> {
  const queryParams = {
    filter: {
      ...(isDefined(query?.["workplace.id"]) && { "workplace.id": query["workplace.id"] }),
      ...(isDefined(query?.["shift.id"]) && { "shift.id": query["shift.id"] }),
      ...(isDefined(query?.applicationSubmitted) && {
        applicationSubmitted: String(query.applicationSubmitted),
      }),
    },
  };

  return useGetQuery({
    url: `${environmentConfig.REACT_APP_BASE_API_URL}/workers/${workerId}/1099-policy/jobs`,
    queryParams,
    responseSchema: GetTen99PolicyJobsResponseSchema,
    meta: { logErrorMessage: APP_V2_APP_EVENTS.GET_TEN99_POLICY_JOBS_FAILURE },
    ...options,
    enabled: isDefined(workerId) && (options.enabled ?? true),
  });
}
